import React from 'react'

const DecisionTagIcon = ({ fillColor, size }) => (
  <svg width={size} height={size} viewBox='0 0 36 36'>
    <defs>
      <pattern id='bdecision' patternUnits='objectBoundingBox' x='0%' width='100%' height='100%'>
        <use xlinkHref='#adecision' />
      </pattern>
      <path
        d='M20.4406127 15.5543072l-3.038404-3.1576436c-.0817955-.0850447-.1920912-.1327601-.3069469-.1327601h-4.2183114V10.256697h5.3856787c.2416815 0 .4377628-.2069673.4377628-.46240254V3.47900733c0-.25543528-.1960813-.46240257-.4377628-.46240257h-5.3856787V.46240256C12.8769504.2069673 12.6808692 0 12.4391877 0H8.13224083c-.24168151 0-.43776274.20696729-.43776274.46240257v2.55420219H3.47616672c-.11485572 0-.22515141.04771538-.30694691.13276012L.13081582 6.30700847C.0470253 6.39401 0 6.5127716 0 6.63665091c0 .12387931.04702529.24264094.13081582.32964244l3.03840399 3.15764355c.0817955.0850448.19209119.1327602.30694691.1327602h4.21831137v2.0072064H2.30879942c-.24168151 0-.43776273.2069673-.43776273.4624026v6.3152871c0 .2554353.19608122.4624026.43776273.4624026h5.38567867v3.1764588c0 .2554353.19608123.4624025.43776274.4624025s.43776273-.2069672.43776273-.4624025v-3.1764588H12.001425v3.1764587c0 .2554353.1960812.4624026.4377627.4624026.2416816 0 .4377628-.2069673.4377628-.4624026v-3.1764587h4.2183114c.1148557 0 .2251514-.0477154.3069469-.1327602l3.038404-3.1576435c.0837905-.0870016.1308158-.2057632.1308158-.3296425s-.0470253-.2426409-.1308159-.3296424zM8.57000356.92480513H12.001425v2.09179963H8.57000356V.92480513zm-4.91457072 8.4070868L1.06191661 6.63665091l2.59351623-2.69524102H17.8248664v5.39048204H3.65543284zm8.34599216.92480517v2.0072064H8.57000356v-2.0072064H12.001425zm4.9145707 8.3224935H2.74656216v-5.390482H16.9159957l2.5935162 2.695241-2.5935162 2.695241z'
        id='edecision'
      />
    </defs>
    <g fill='none' fillRule='evenodd'>
      <g transform='translate(-881 -364)'>
        <g>
          <g transform='translate(888.714286 370.428571)'>
            <mask id='fdecision' fill='#fff'>
              <use xlinkHref='#edecision' />
            </mask>
            <use fill={fillColor || '#000'} fillRule='nonzero' xlinkHref='#edecision' />
            <g mask='url(#fdecision)' fill={fillColor || '#000'}>
              <path d='M-7.714286-6.428571h36v36h-36z' />
            </g>
          </g>
        </g>
      </g>
    </g>
  </svg>
)

export default DecisionTagIcon
